'use strict';

var _ = require('lodash');
var FlightLiveDataService = function FlightLiveDataService($log, restangular, liveDataTimeHelperService) {
  var notificationService = restangular.service('domain/flights/changes?noSpinner=true');
  var lastRefreshTime = {
    'cabin-flight-analysis': null,
    'class-flight-analysis': null,
    'segment-flight-analysis': null,
    'service-flight-analysis': null
  };
  function setLastRefreshTime(grid, time) {
    lastRefreshTime[grid] = time;
  }
  var cabinSelectedRows = [];
  function setCabinSelectedRows(selectedRows) {
    cabinSelectedRows = selectedRows;
  }
  function callForNotification(subscription) {
    var payload = {
      lastEventTimeStamp: liveDataTimeHelperService.getOldestLastRefreshTime(lastRefreshTime),
      flightIds: _.chain(subscription.data).map('flightId').uniq().value()
    };
    return notificationService.post(payload).then(function (data) {
      return liveDataTimeHelperService.transformChangesTimeStamps(data);
    })["catch"](function () {
      $log.warn('Cannot fetch live data for Flight domain!');
    });
  }
  function isMatchingGridData(dataToCompare, change) {
    return _.find(dataToCompare, {
      flightId: change.id
    });
  }
  function isChangeNewAndMatchGridData(gridId, dataToCompare, change) {
    return isMatchingGridData(dataToCompare, change) && change.modificationDateTime.isAfter(lastRefreshTime[gridId]);
  }
  function findNotificationForLayerInGrid(gridId, dataToCompare, layerNotification) {
    var changedForGrid = [];
    _.forEach(layerNotification, function (change) {
      if (isChangeNewAndMatchGridData(gridId, dataToCompare, change)) {
        changedForGrid.push(change.id);
      }
    });
    return changedForGrid;
  }
  function prepareNotificationForFlightToolbar(gridId, subscription, loadedData) {
    var dataToCompare = loadedData;
    if (gridId === 'service-flight-analysis') {
      dataToCompare = !_.isEmpty(cabinSelectedRows) ? cabinSelectedRows : subscription.loadedData['cabin-flight-analysis'];
    }
    var notification = subscription.notification;
    return {
      l2: findNotificationForLayerInGrid(gridId, dataToCompare, notification.layer2Changes),
      l3: findNotificationForLayerInGrid(gridId, dataToCompare, notification.layer3Changes)
    };
  }
  return {
    callForNotification: callForNotification,
    setLastRefreshTime: setLastRefreshTime,
    setCabinSelectedRows: setCabinSelectedRows,
    prepareNotificationForFlightToolbar: prepareNotificationForFlightToolbar
  };
};
FlightLiveDataService.$inject = ['$log', 'Restangular', 'LiveDataTimeHelperService'];
module.exports = FlightLiveDataService;